import type { SummaryDataFormatted } from '@fire-b2b/composables/cart/useCartHelper'
import type { ConfirmationAlertMessage } from '@fire-b2b/composables/checkout/checkout.types'

export interface BasketCheckoutConfirmationData {
  summary?: SummaryDataFormatted
  commission?: string
  comment?: string
}

export function useBasketCheckoutConfirmation() {
  const t = useTranslate()
  const { email } = useUserInfoStore()

  const confirmationState = useState<BasketCheckoutConfirmationData | null>('basket-checkout-confirmation', () => null)

  const alertMessage = computed<ConfirmationAlertMessage>(() => ({
    type: 'success',
    title: t('notification.sendOrderSuccessTitle'),
    message: t('notification.sendOrderSuccessMessage', { email }),
  }))

  const orderDataList = computed(() => {
    const data = confirmationState.value
    if (!data) {
      return []
    }

    const list: { caption: string; value: string }[] = []

    if (data.commission) {
      list.push({
        caption: t('common.customerOrderNo'),
        value: data.commission,
      })
    }

    if (data.comment) {
      list.push({
        caption: t('common.comment'),
        value: data.comment,
      })
    }

    return list
  })

  function setConfirmationData(data: BasketCheckoutConfirmationData) {
    confirmationState.value = data
  }

  return {
    confirmationState,
    alertMessage,
    orderDataList,
    setConfirmationData,
  }
}
